export default "__VITE_ASSET__bb7d6b70__"